import axios from 'axios'
import qs from 'qs'
import Message from 'element-ui/lib/message'
//这个加上后，后端返回的response里不出现credentials相关的内容
//不加上的话，session不能保持
axios.defaults.withCredentials=false;
// 超时（2026-10-17）：原来是 0 = 永不超时。后果是任何请求只要不返回，
// 页面就永远转圈、既不到 then 也不到 catch，用户只能强刷（表现为「登录卡住」）。
// 现在给一个上限：超时会走 error 分支，前端能提示「网络异常，请稍后重试」并允许重试。
// 15s 的取值依据：线上 99% 接口 rt<1s，长尾（如 mail/letter/list）出现过 1.2s，
// 15s 足够覆盖正常慢请求，又不至于让玩家干等太久。
axios.defaults.timeout=15000;
 axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
// 环境配置化：地址在 .env.development / .env.production 中通过 VUE_APP_ 前缀配置
//
// 【同源模式】
//   把对应变量留空、写成 "/" 或写成哨兵值 "__SAME_ORIGIN__"，则运行期自动取
//   当前页面地址（window.location.origin）作为后端基址。
//   好处：内网 IP / 域名 / 花生壳内网穿透 / https 反代 随便换，前端都不用重新构建；
//   且页面与接口天然同源，浏览器侧零跨域。
//   典型场景：测试机、穿透域名不固定的部署。
//
//   注意：不能用「留空字符串」以外的隐式判断 —— 未配置时也按同源处理，
//   所以正式生产构建必须在 .env.production 里显式给出绝对地址（仓库里已有）。
const SAME_ORIGIN = '__SAME_ORIGIN__';
const runtimeOrigin =
  (typeof window !== 'undefined' && window.location && window.location.origin) || '';
const isSameOrigin = (value) => !value || value === '/' || value === SAME_ORIGIN;

// axios 基址：同源时用相对路径（'' → 实际发出 /auth/login/ajaxLogin），跨域时才用绝对地址
export const base = isSameOrigin(process.env.VUE_APP_BASE_URL)
  ? ''
  : process.env.VUE_APP_BASE_URL;

// SockJS 内部会自行拼接 /info 等子路径，必须给绝对地址 → 同源时用运行期 origin 拼出来
export const chatUrl = isSameOrigin(process.env.VUE_APP_CHAT_URL)
  ? runtimeOrigin + '/chat'
  : process.env.VUE_APP_CHAT_URL;
export const chatSocketUrl = isSameOrigin(process.env.VUE_APP_CHAT_SOCKET_URL)
  ? runtimeOrigin + '/chat/webSocketServer'
  : process.env.VUE_APP_CHAT_SOCKET_URL;

export const postRequest = (url, data) => {
  return axios.post(`${base}${url}`, data);
}
export const postJson = (url, data) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}
export const postChatRequest = (url, params) => {
  return axios.post(`${chatUrl}${url}`, params);
}
export const uploadFileRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
export const putRequest = (url, params) => {
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
export const deleteRequest = (url) => {
  return axios({
    method: 'delete',
    url: `${base}${url}`
  });
}
// 统一处理 API 响应，消除重复的 HTTP 状态 + 业务状态嵌套检查
// callbacks: { success, onError, onHttpError }
// success(data) — 业务成功（status === 200）
// onError(data) — 业务失败（status !== 200），默认 Message.error
// onHttpError(resp) — HTTP 失败（resp.status !== 200），默认 Message.error
export const onResult = (resp, callbacks) => {
  callbacks = callbacks || {};
  if (resp.status === 200) {
    const data = resp.data;
    if (data && data.status === 200) {
      if (callbacks.success) callbacks.success(data);
    } else {
      if (callbacks.onError) {
        callbacks.onError(data);
      } else {
        Message.error((data && data.message) || '操作失败');
      }
    }
  } else {
    if (callbacks.onHttpError) {
      callbacks.onHttpError(resp);
    } else {
      Message.error('网络异常，请稍后重试');
    }
  }
};

export const getRequest = (url,params) => {
  const query = qs.stringify(params);
  return axios({
    method: 'get',
    url: `${base}${url}${query ? '?' + query : ''}`,
    //data:qs.stringify(params),
    // transformRequest: [function (data) {
    //   let ret = ''
    //   for (let it in data) {
    //     ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    //   }
    //   alert(ret)
    //   return ret
    // }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
